import type { DomainMapper } from '../types';

const de: DomainMapper = {
  countryCode: 'de',
  currency: 'EUR',
  dataAreaId: 'de20',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/DE.svg',
  languagePrimary: true,
  locale: 'de',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-de.xml',
  storyblokBasePath: 'de',
  url: 'https://localhost:3011/de',
  algoliaIndex: 'b2b-de-de-DE-products',
  algoliaIndexAutocomplete: 'b2b-de-de-DE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1351, // stage
  // applicationId: 1355, // prod
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1351, // stage
    // applicationId: 1355, // prod
    algoliaIndex: 'b2b-de-de-DE-products',
    algoliaIndexAutocomplete: 'b2b-de-de-DE-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-de.xml',
  },
  b2c: {
    enabled: true,
    productBasePath: 'produkt',
    storyblokBasePath: '',
    algoliaIndex: 'b2c-de-de-DE-products',
    algoliaIndexAutocomplete: 'b2c-de-de-DE-products_query_suggestions',
    applicationId: 1423,
    displayIncVat: true,
    default: false,
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    onlyAllowCustomerEditAddressesForSamples: true,
    disableShipToConsumer: false,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default de;
